<template>
  <Content id="roles">

    <div slot="search">
      <Form :label-width="70" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="地区名称"><Input v-model="search.areaName" :clearable="true"/></FormItem></Col>
          <Col>
            <FormItem label="pc端" :label-width="45">
              <Select v-model="search.pc" style="width: 100%;" :clearable="true">
                <Option v-for="item in pcList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="小程序端">
              <Select v-model="search.miniProgram" style="width: 100%;" :clearable="true">
                <Option v-for="item in miniProgramList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态" :label-width="45">
              <Select v-model="search.status" style="width: 100%;" :clearable="true">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value" style="width: 100%;">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="query">查询</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button size="small" icon="md-add" @click="handleCreate" type="primary">添加</Button>
        </div>
      </div>
    </div>

    <el-table :data="dataList" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center', 'height':'40px'}"
              :row-class-name="tableRowClassName" @row-click="selectrow"
              highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column fixed align="center" prop="areaName" label="地区" min-width="100"/>
      <el-table-column fixed align="center" prop="code" label="校验码" min-width="80"/>
      <el-table-column fixed align="center" prop="areaCode" label="地区编号" min-width="80"/>
      <el-table-column align="center" prop="expiredTime" label="失效时间" min-width="150"/>
      <el-table-column fixed="right" align="center" prop="pc" label="pc端"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.pc" :active-value="1" :inactive-value="2" @change="handleEditPC(row, null, row.pc)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="miniProgram" label="小程序端"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.miniProgram" :active-value="1" :inactive-value="2" @change="handleEditMiniProgram(row, null, row.miniProgram)"/>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operator" label="最后操作人" min-width="150">
        <template #default="{ row }">
          <div>{{ row.operatorAccount }}</div>
          <div>{{ row.operator }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="updateTime" label="最后操作时间" min-width="160"/>
      <el-table-column fixed="right" align="center" prop="status" label="状态"  min-width="60">
        <template slot-scope="{row}">
          <el-switch v-model="row.status" :active-value="1" :inactive-value="2" @change="handleEditStatus(row, null, row.status)"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" prop="operation" label="操作"  min-width="50">
        <template slot-scope="{row}">
          <el-button type="text" size="medium" @click="setTime(row)">设置</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total :page-size-opts="[10, 30, 50, 100]"
          @on-change="chagecurrent" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

    <Modal ref="modalRef" v-model="editWindow" width="30%" :title="windowTitle" :styles="{'top':'60px'}" :mask-closable="false">
      <WechatLoginCodeEdit ref="edit"  @on-submit="handleSubmit" />
      <div slot="footer">
        <Button type="primary" @click="submit">确定</Button>
        <Button @click="editWindow = false">取消</Button>
      </div>
    </Modal>

  </Content>
</template>
<script>
import {
  _getSelectPages, getDelay, getUpdateStatus, getUpdatePC, getUpdateMiniProgram
} from "@/services/temporaryLogin/wechatLoginCode.js";
import dayjs from "dayjs";
import WechatLoginCodeEdit from "@/views/temporaryLogin/wechatLoginCode/wechatLoginCodeEdit.vue";
export default {
  name: "WechatLoginCode",
  components: {WechatLoginCodeEdit},
  data() {
    return {
      search: {
        areaName:"",
        areaCode:"",
        pc:"",
        miniProgram:"",
        status:"",
        endDate:dayjs().format('YYYY-MM-DD'),
        startDate:dayjs().format('YYYY-MM-DD')
      },
      pcList:[
        {label: '全部', value: ''},
        {label: '开启', value: 1},
        {label: '关闭', value: 2},
      ],
      miniProgramList:[
        {label: '全部', value: ''},
        {label: '开启', value: 1},
        {label: '关闭', value: 2},
      ],
      statusList:[
        {label: '全部', value: ''},
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      windowTitle:"新增",
      editWindow:false,
      tableHeight: 0,
      currentRowIndex: null,
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dataList:[],
      hour:"",
    };
  },
  created() {
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
      this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _getSelectPages({
          ...this.formItem,
          ...this.pageList,
        }).then(res => {
          if (res.errcode == 1){
            this.dataList = res.data.records;
            this.pageList.total = res.data.total;
          } else {
            this.$message.error(res.errmsg)
          }
        }).catch(() => {});
    },
    handleEditPC(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用 " : "停用 "}${row.areaName} PC端登录吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            getUpdatePC({id:row.id, pc: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    handleEditMiniProgram(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用 " : "停用 "}${row.areaName} 小程序端登录吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            getUpdateMiniProgram({id:row.id, miniProgram: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用 " : "停用 "}${row.areaName} 吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then((result)=>{
            getUpdateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode === 1) {
                this.handleDataList();
              }else {
                this.$message.error(res.errmsg);
                reject()
              }
            }).catch(() => {
              reject()
            });
          }).catch(function (e) {
            if (e === 'cancel' || e === 'close') {
              row.status = (targetValue === 1 ? 2 : 1);
            }
          })
        });
      }
    },
    updateStatus(item) {
      this.$confirm('<h3>是否确定 ' + (item.status == 1 ? "<span style='color: red'>关闭</span>" : "<span style='color: rgb(87, 164, 72);'>开启</span>") + " " + item.areaName + '校验码?</h3>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal:false,
        dangerouslyUseHTMLString: true
      }).then(() => {
        getUpdateStatus({id: item.id, status: (item.status == 1 ? 2 : 1)}).then(res => {
          if (res && res.errcode && res.errcode == 1) {
            this.handleDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.errmsg,
              duration: 4000
            });
          }
        }).catch(() => {
        });
      }).catch(() => {});
    },
    setTime(item) {
      let _hour = item.expiredTime.substring(11, 13);
      this.$prompt('', '设置失效时间', {
        type: "warning",
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: "请输入小时(24小时制)",
        inputValue: _hour,
        inputPattern: !/\d+/g,
        closeOnClickModal:false,
        inputType: "number",
        inputValidator:function (value) {
          if(!value || value.length > 2 || parseInt(value) < 0 || parseInt(value) > 23){
            return "只能输入数字0-23！";
          }else if(parseInt(_hour) > parseInt(value)){
            return "时间不能小于失效时间";
          }
          return true;
        },
        inputErrorMessage: '只能输入数字0-23并且不能小于当前失效时间'
      }).then(({ value }) => {
          getDelay({id:item.id, hour: value}).then(res => {
            if (res && res.errcode && res.errcode == 1){
              this.$message.success("设置成功");
              this.handleDataList();
            } else{
              this.$message({
                type: 'error',
                message: res.errmsg,
                duration: 4000
              });
            }
          }).catch(() => {});
      }).catch(() => {});
    },
    handleCreate() {
      this.windowTitle = "新增";
      this.editWindow = true;
      this.$refs["edit"].handleModal();
    },
    handleEdit(row) {
      this.windowTitle = "编辑";
      this.editWindow = true;
      this.$refs["edit"].handleModal(row);
    },
    submit(){
      this.$refs['edit'].handleSubmit();
    },
    handleSubmit(result) {
      if(!result){
        this.editWindow = result;
        this.handleDataList();
      }
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e){
      this.pageList.currentPage=e
      this.handleDataList()
    },
    chagepagesize(e){
      this.pageList.pageSize=e
      this.handleDataList()
    },
    changestart(e){
      this.formItem.startDate=e
    },
    changeend(e){
      this.formItem.endDate=e
    },
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table .el-table__cell {padding: 4px 0;}

</style>
